module.exports = __webpack_public_path__ + "img/Picture2.25f6218b.png";